import { INDICADOR_TIPO } from '@investirapri/financa.js/lib/enums';

const ROUTES_INDICADORES_TIPO = {
  'correcao-monetaria': {
    ...INDICADOR_TIPO.C,
    iconName: 'coins',
    metadata: {
      description:
        'Indicadores usados para acompanhar a inflação e a atualização monetária de valores.'
    }
  },
  juros: {
    ...INDICADOR_TIPO.J,
    iconName: 'percent',
    metadata: {
      description: 'Taxas e referências de juros utilizadas no mercado financeiro.'
    }
  },
  'indices-de-mercado': {
    ...INDICADOR_TIPO.I,
    iconName: 'chart_line',
    metadata: {
      description: 'Índices que representam o desempenho de mercados e classes de ativos.'
    }
  },
  moedas: {
    ...INDICADOR_TIPO.M,
    iconName: 'coin',
    metadata: {
      description: 'Moedas e referências cambiais acompanhadas pelo mercado financeiro.'
    }
  },
  metais: {
    ...INDICADOR_TIPO.T,
    iconName: 'metal',
    metadata: {
      description: 'Metais utilizados como referência de valor e investimento.'
    }
  }
};

export default ROUTES_INDICADORES_TIPO;
